import {numUtil} from '@/helper/num';

export const klineUtil = {
  convertToBar(raw, item, isPerpetualV2) {
    const {pricePrecision, priceScale} = item;
    const scale = isPerpetualV2 ? 0 : priceScale;
    //"timestamp", "interval", "last_close", "open", "high", "low", "close", "volume", "turnover"
    return {
      close: Number(numUtil.floor(raw[6], pricePrecision, scale)),
      high: Number(numUtil.floor(raw[4], pricePrecision, scale)),
      low: Number(numUtil.floor(raw[5], pricePrecision, scale)),
      open: Number(numUtil.floor(genPriceEp(raw), pricePrecision, scale)),
      time: raw[0] * 1e3,
      volume: raw[7],
    };
  },
  convertToBar2(raw, {pricePrecision}) {
    return {
      close: Number(numUtil.floor(raw.close, pricePrecision)),
      high: Number(numUtil.floor(raw.high, pricePrecision)),
      low: Number(numUtil.floor(raw.low, pricePrecision)),
      open: Number(numUtil.floor(raw.open, pricePrecision)),
      time: raw.time,
      volume: raw.volume,
    };
  },
};

function genPriceEp(item) {
  if (item.length <= 0) {
    return 0;
  }
  const lastPriceEp = Number(item[2]);
  const openPriceEp = Number(item[3]);
  // 解决刚开盘last_close的价格为0导致k线open展示为0的问题
  return lastPriceEp > 0 ? lastPriceEp : openPriceEp;
}
